import React from "react";
import { Button } from "flowbite-react";
import { useHistory } from "react-router-dom";

const MirumBtn = ({
  className,
  children,
  onClick,
  useNegativeStyle,
  disabled,
  type,
  href,
  bgColor,
}) => {
  const history = useHistory();
  if (href) {
    onClick = () => {
      history.push(href);
    };
  }

  let bgClass = useNegativeStyle ? "" : "bg-[var(--peachy-pink)]";
  if (bgColor === "blue") {
    bgClass = `bg-[var(--blue)]`;
  }
  return (
    <button
      type={type}
      className={`grow rounded-full ${bgClass} p-4 lowercase ${
        useNegativeStyle ? "" : "text-white"
      } ${
        disabled ? "opacity-50" : "hover:scale-105"
      } transform transition duration-300 ease-in-out font-black ${
        className ? className : ""
      }`}
      onClick={onClick}
      disabled={disabled}
      style={{
        boxShadow: "0 2px 10px rgba(91,115,222,0.27)",
      }}
    >
      {children}
    </button>
  );
};

export default MirumBtn;
